// src/errnotification/context/NotificationContext.jsx
import React, { createContext, useContext } from 'react';
import { useNotification as useNotificationHook } from '../hooks/useNotification';
import ToastNotification from '../components/ToastNotification';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const { notifications, showNotification, removeNotification } = useNotificationHook();

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      {notifications.map(({ id, message, type, duration }) => (
        <ToastNotification
          key={id}
          message={message}
          type={type}
          duration={duration}
          onClose={() => removeNotification(id)}
        />
      ))}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification debe usarse dentro de NotificationProvider');
  }
  return context;
};